import React from 'react';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { connect } from 'react-redux';
import * as actions from '../../../actions/productData';
import properties from '../../../modules/ajio-util/properties';
import {
  getShoppingAssistantDetails,
  getIsShoppingAssistantPDP,
  getServiceabilityDetailsDetails,
  getErrorInServiceabilityFetching,
  getIsCheckServiceabilityCalledForRex,
  getProductServiceAbility
} from '../../../refresh/selectors/productpage';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import luxeScreens from '../../../refresh/constants/luxeScreenType';
import { getCurrentStore } from '../../../refresh/selectors/metaData';
import { Feature, Variant } from '../../../refresh/organism/ABFeature';
import { signInCheck } from '../../common/CheckUserStatus';
import { getReturnCodCommunication } from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


const { pdp: { screenType = '', screenName = '' } = {} } = luxeScreens;

var holdStarter = null;
var holdDelay = 300;
var holdActive = false;
class ProductDetailsTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pincode: '',
      error: '',
      errored: false
    };
    this.setInputValue = this.setInputValue.bind(this);
    this.saveInput = this.saveInput.bind(this);
    this.checkValidInput = this.checkValidInput.bind(this);
  }

  handleError(event) {
    this.setState({ errored: true });
  }

  setInputValue(event) {
    var value = event.target.value;
    return this.setState({ pincode: value });
  }

  handleKeyPress = event => {
    event = event || window.event;
    if (event.charCode == 13) {
      this.saveInput(event);
    }
  };

  onKeyDown = e => {
    if (e.keyCode === 8 || e.keyCode === 46) {
      this.setState({ error: ' ' });
    }
  };

  checkValidInput() {
    var formIsValid = true;
    var pinCode = this.state.pincode;
    if (
      pinCode.length > 6 ||
      pinCode.length < 6 ||
      !pinCode.match(/^\d+/) ||
      parseFloat(pinCode) != parseInt(pinCode) ||
      isNaN(pinCode)
    ) {
      this.state.error = 'Please enter valid pincode';
      formIsValid = false;
    }
    this.setState({ error: this.state.error });
    return formIsValid;
  }

  saveInput(event) {
    event.preventDefault();
    let { prodData } = this.props;
    let sizeVariant;
    prodData.baseOptions.map((variant, i) => {
      if (variant.variantType === 'FnlSizeVariant') {
        sizeVariant = variant.options;
      }
    });

    if (sizeVariant === undefined) {
      sizeVariant = prodData.variantOptions;
    }
    let sizeCode = sizeVariant[0].code;
    const filterByStock = size => {
      let flag = false;
      if (size.stock.stockLevelStatus !== 'outOfStock') {
        sizeCode = size.code;
        flag = true;
      }
    };
    let filterData = sizeVariant.filter(filterByStock);
    let pincode = this.state.pincode;
    if (this.checkValidInput()) {
      this.setState({ error: '' });
      this.props.setPincode(sizeCode, pincode);
    }
  }

  onMouseDown = () => {
    holdStarter = setTimeout(function() {
      holdStarter = null;
      holdActive = true;
      // begin hold-only operation here, if desired
    }, holdDelay);
  };

  onMouseUp = value => {
    if (holdStarter) {
      clearTimeout(holdStarter);
      window.open(`tel:+91${value}`);
      gtmEventPush({
        event: 'Helpline_number',
        event_category: 'product details interactions',
        event_action: 'click',
        event_label: 'New',
        page_name: screenName,
        page_type: screenType,
        store_type: 'luxe'
      });
    }
    // Otherwise, if the mouse was being held, end the hold
    else if (holdActive) {
      holdActive = false;
      // end hold-only operation here, if desired
      this.onCopyToClipBoard(value);
    }
  };

  onCopyToClipBoard = value => {
    navigator.clipboard.writeText(value);
    gtmEventPush({
      event: 'Helpline_number',
      event_category: 'product details interactions',
      event_action: 'copy',
      event_label: 'New',
      page_name: screenName,
      page_type: screenType,
      store_type: 'luxe'
    });
  };

  shoppingAssistantComponent = () => {
    let { shoppingAssistantData, currentStore } = this.props;
    return (
      <>
        <div>
          Have doubts about this product? Our experienced shopping assistants are here to help you
          with all your queries. Happy shopping!
        </div>
        <div className="helpline">
          <img src={`${properties.getProperty('imageBaseUrl')}/static/img/luxe-call.svg`} alt='Call icon'/>
          <div>
            <p className="help-num">
              <strong>Helpline number</strong>
            </p>
            <p className="timing">{shoppingAssistantData.time}</p>
          </div>
          <div className="contact-num">
            {shoppingAssistantData.phoneNumber &&
              shoppingAssistantData.phoneNumber.map((key, index) => {
                return (
                  <>
                    {index != 0 && ' | '}
                    <div
                      className="phone-number"
                      onMouseDown={() => this.onMouseDown()}
                      onMouseUp={() => this.onMouseUp(key)}
                    >
                      <strong tabIndex={0}
                        role='link'
                        aria-label={`Helpline number - ${key}`}
                        style={{
                          textDecoration:"underline"
                        }}
                        onClick={() => {
                          this.onMouseDown()
                          this.onMouseUp(key)
                        }}>{key}</strong>
                    </div>
                  </>
                );
              })}
          </div>
        </div>
      </>
    );
  };

  checkReturnExchangeAvailability = (returnCodCommunication) => {
    const isSignedIn = signInCheck();
    const {isCheckServiceabilityCalledForRex, errorInServiceabilityFetching} = this.props;
    const { returnExchangeData = {} } = this.props.productServiceAbility;
    const {
      isExchangeable: pdpisExchangeable = 'false',
      isReturnable: pdpisReturnable = 'false',
      returnWindow: pdpReturnEdd
    } = returnExchangeData;
    const { cod = {}, returnWindow = {} } = this.props.serviceabilityDetails;
    const { codAllowed = false } = cod;
    const { actionContent = {} } = returnWindow;
    const { returnWindow: returnEdd, isExchangeable = false, isReturnable = false } = actionContent;
    const isReturnableExchangeableSignedIn = isReturnable && isExchangeable  && pdpisReturnable === 'true' && pdpisExchangeable === 'true'
    const isReturnableExchangeableSignedOut = pdpisReturnable === 'true' && pdpisExchangeable === 'true';
    const lowerReturnEdd = returnEdd < pdpReturnEdd ? returnEdd : pdpReturnEdd;
    const messageReturnAndExchange = returnCodCommunication?.messageReturnAndExchangeDesktop?.replace(
      '%x',
      lowerReturnEdd
    );
  
    const messageReturn = returnCodCommunication?.messageReturnDesktop?.replace('%x', lowerReturnEdd);
    const messageExchange = returnCodCommunication?.messageExchangeDesktop?.replace('%x', lowerReturnEdd);
    let returnExchangeMessage = '';
    if(isSignedIn && isCheckServiceabilityCalledForRex && !errorInServiceabilityFetching){
      if(isReturnableExchangeableSignedIn && lowerReturnEdd > 0){
        console.log("RETURN EXCHANGE AVAILABLE")
        returnExchangeMessage = messageReturnAndExchange;
      }else if(isReturnable && pdpisReturnable === 'true' && lowerReturnEdd > 0){
        console.log("RETURN  AVAILABLE")
        returnExchangeMessage = messageReturn;
      }else if(isExchangeable && pdpisExchangeable === 'true' && lowerReturnEdd > 0){
        console.log("EXCHANGE AVAILABLE")
        returnExchangeMessage = messageExchange;
      }else {
        console.log("NO RETURN EXCHANGE")
        returnExchangeMessage = returnCodCommunication?.messageNoReturnAndExchangeDesktop;
      }
    } else if(isReturnableExchangeableSignedOut && lowerReturnEdd > 0){
      console.log("PDP RETURN EXCHANGE AVAILABLE")
      returnExchangeMessage = messageReturnAndExchange;
    }else if(pdpisReturnable === 'true' && lowerReturnEdd > 0){
      console.log(" PDP RETURN  AVAILABLE")
      returnExchangeMessage = messageReturn;
    } else if(pdpisExchangeable === 'true' && lowerReturnEdd > 0){
      console.log("PDP EXCHANGE AVAILABLE")
      returnExchangeMessage = messageExchange;
    }else{
      console.log("NO RETURN EXCHANGE")
      returnExchangeMessage = returnCodCommunication?.messageNoReturnAndExchange;
    }
    return returnExchangeMessage;
  };
  render() {
    var errClass = '';
    if (this.state.error) {
      errClass += 'error';
    }
    let prodData = this.props.prodData;
    const { newDesignLuxe } = this.props;
    let { brandName } = prodData.fnlColorVariantData;
    let {
      deliveryText,
      qualityAssuranceLogo,
      qualityAssuranceText,
      returnContent,
      returnTitle,
      returnUrl,
      ourPromise,
      pdpFaqLink = ''
    } = prodData;
    let { pincodeDetails = {}, shoppingAssistantData, shoppingAssistantFlag, returnCodCommunication } = this.props;
    let {
      codAllowedForPincode = '',
      message = '',
      pdpDeliveryText = '',
      itemStatus = ''
    } = pincodeDetails;
    let isReturnCommunicationPdpEnabled = returnCodCommunication?.isPdpEnabled;
    let returnExchangeMsg = ''
    if(isReturnCommunicationPdpEnabled){
      returnExchangeMsg = this.checkReturnExchangeAvailability(returnCodCommunication);
    }
    
    return (
      <div className="product-details-tab-block" id="product-details-tab">
        <Tabs
          defaultActiveKey={newDesignLuxe && shoppingAssistantFlag ? 1 : 2}
          id="product-details-tab"
        >
          {newDesignLuxe && shoppingAssistantFlag && (
            <Tab
              eventKey={1}
              title={
                <span className="shopping-tab">
                  SHOPPING ASSISTANT <div className="new-label-tab">NEW</div>{' '}
                </span>
              }
            >
              <Feature featureName="Assisted_Selling_Module_PDP">
                <Variant id="0">{this.shoppingAssistantComponent()}</Variant>
                <Variant id="1">{this.shoppingAssistantComponent()}</Variant>
              </Feature>
            </Tab>
          )}
          {returnContent && (
            <Tab eventKey={2} title="RETURNS" aria-label="RETURNS">
              <div className="return-desc">
                <span key="returnContent" dangerouslySetInnerHTML={{ __html: isReturnCommunicationPdpEnabled ? returnExchangeMsg : returnContent }} />
                {!returnTitle || !returnUrl ? (
                  <span key="returnLink" aria-label="Have questions? Read our Returns Policy">
                    &nbsp;Have questions? Read our
                    <a
                      className="pdp-return-url-title"
                      href="https://www.ajio.com/return-refund-policy"
                    >
                      &nbsp;Returns Policy
                    </a>
                    &#8228;
                  </span>
                ) : (
                  <span key="returnLink">
                    {' '}
                    <a
                      href={`${returnUrl}`}
                      target="_blank"
                      aria-label={`${returnTitle.replace(/<[^>]*>/g, '')} to get more information on ${isReturnCommunicationPdpEnabled ? returnExchangeMsg : returnContent} opens in a new tab`}
                    >
                      <span dangerouslySetInnerHTML={{ __html: returnTitle }} />
                       <img
                       src={`${properties.getProperty('imageBaseUrl')}/static/img/open-new-tab-icon.svg`}
                       alt="Opens in new tab"
                      style={{marginLeft: '2px', verticalAlign: 'middle' }}
                       />
                    </a>
                    &#8228;
                  </span>
                )}
              </div>
            </Tab>
          )}
          {brandName === 'AJIO' && qualityAssuranceText && (
            <Tab eventKey={3} title={newDesignLuxe ? 'OUR PROMISE' : 'QUALITY ASSURANCE'}>
              {!this.state.errored && (
                <div className="qc-logo">
                  <img
                    title="Three Stage Quality Check Banner"
                    src={`${replaceWithJioCDN(qualityAssuranceLogo)}`}
                    onError={this.handleError}
                  />
                </div>
              )}
              <div className="qc-desc">{qualityAssuranceText}</div>
            </Tab>
          )}
          {brandName !== 'AJIO' && ourPromise && (
            <Tab eventKey={3} title="OUR PROMISE" aria-label="OUR PROMISE">
              {ourPromise}
            </Tab>
          )}
        </Tabs>
        <a href={pdpFaqLink} target="_blank" className="service-faq" aria-label="Service FAQs opens in a new tab">
          Service FAQs
          <img
          src={`${properties.getProperty('imageBaseUrl')}/static/img/open-new-tab-icon.svg`} alt="" aria-hidden="true"
          style={{ marginLeft: '2px', verticalAlign: 'middle' }}
          />
        </a>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return {
    currentStore: getCurrentStore(state),
    pincodeDetails: state.product.pincode,
    shoppingAssistantData: getShoppingAssistantDetails(state),
    shoppingAssistantFlag: getIsShoppingAssistantPDP(state),
    serviceabilityDetails: getServiceabilityDetailsDetails(state),
    errorInServiceabilityFetching: getErrorInServiceabilityFetching(state),
    isCheckServiceabilityCalledForRex: getIsCheckServiceabilityCalledForRex(state),
    productServiceAbility: getProductServiceAbility(state), // serviceability from current pdp aggregator api,
    returnCodCommunication: getReturnCodCommunication(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPincode: (id, pid) => dispatch(actions.setPincode(id, pid))
  };
};

export default ProductDetailsTab = connect(mapStateToProps, mapDispatchToProps)(ProductDetailsTab);
